import React, {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Alert, AlertTitle } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@material-ui/core/Button';
import {fetchUnsur, fetchKategori, fetchSearchUnsur , fetchSearchDomain} from '../../api/kugi';
import {fetchDictionaryDesc} from '../../api/dictionary';
import {pushCategory, pushUnsurAll, pushUnsurResultAll, pushUnsurResultDic, pushSearchText} from '../../actions/general';
import { connect } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import _ from 'lodash';
import { withRouter, Redirect } from "react-router";
import AppBar from '@material-ui/core/AppBar';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import InputBase from '@material-ui/core/InputBase';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

import { css } from "@emotion/core";
import {BarLoader} from "react-spinners";

const override = css`
position: absolute;
  top: 50%;
  left: 40%;
  margin: 0 auto;
`;

function getSkala(codenya) {
  let code = codenya.replace("@en", "");

  let a = code.slice(4, 6);
  let skala = '';

  switch (a){
    case "01":
    skala = "1:1.000.000";
    break;
    case "02":
    skala = "1:500.000"
    break;
    case "03":
    skala = "1:250.000"
    break;
    case "04":
    skala = "1:100.000"
    break;
    case "05":
    skala = "1:50.000"
    break;
    case "06":
    skala = "1:25.000"
    break;
    case "07":
    skala = "1:10.000"
    break;
    case "08":
    skala = "1:5.000"
    break;
    case "09":
    skala = "1:2.500"
    break;
    case "10":
    skala = "1:1.000"
    break;
  }

  return skala;
}

class PencarianKugi extends Component{

  constructor(props) {
    super(props);
    this.state = {
      featureType : [],
      optFeatureType:[],
      featureCatagory: [],
      search: "",
      resultSearchDic: [],
      resultSearchAll: [],
      resultSearchAtribut: [],
      resultSearchDomain: [],
      mode: 'unsur',
      valueTab: "1",
      loading: true
    }
  }

  componentWillMount(){
    let unsurx = [];

    this.setState({search:this.props.searchText});

    fetchKategori()
      .then(response => {
        let arr = null;
        let letfind = false;
        let totalarrterakhir;

        this.setState({featureCatagory:response.data });
        let loop = response.data.length;
        response.data.map((e)=>{

          loop = loop-1;
          this.setState({ loading: true });

          fetchUnsur(e.featureCatalogId.replace("@en", ""))
            .then(response2 => {

              let  totalarrterakhir = response2.data.length;

              response2.data.map((ee)=>{
                if(loop == 0){
                    totalarrterakhir = totalarrterakhir-1;
                }
                unsurx.push({
                  definition: ee.definition,
                  featureTypeID: ee.featureTypeID,
                  code: ee.code,
                  typeName: ee.typeName,
                  aliases: ee.aliases,
                  featureCatalogueId: e.featureCatalogId.replace("@en", "")
                });

                if(this.state.search){
                  if(loop == 0){
                    letfind = true;
                    if(totalarrterakhir == 0){
                      this.handleSearch("unsur");
                    }
                  }
                }

              });

              let b2 = _.uniqBy(unsurx, 'typeName');
              this.setState({featureType:unsurx, optFeatureType:b2});
              this.setState({ loading: false });
            }).catch(error => {
              console.log(error);
            });

        });

      }).catch(error => {
        console.log(error);
      });
  }

   handleChangeTab = (event, newValue)=>{
     this.setState({valueTab: newValue})
   }

   handleClickOpen = (e)=>{
     this.setState({open:!this.state.open});
     this.setState({valueTab: "1"});
   }
   handleClickOpen2 = (e)=>{
     this.setState({open:!this.state.open});
     this.setState({valueTab: "2"});
   }

   handleSubmit = (e)=>{
     console.log(e.target[0].value);
     this.handleSearch(this.state.mode);
     this.setState({loading:true});

     e.preventDefault();
   }

   handleResultAtribut = ()=>{
     return (
       <div>asd</div>
     )
   }

   handleMode = (e) => {
     this.setState({mode:e.target.value});
     this.handleSearch(e.target.value);
   }

    handleSearch = (mode)=> {
      this.setState({ loading: true });
      this.setState({resultSearchAll: [], resultSearchDic:[]});
      console.log(mode);

      let a = this.state.search.split(" ", 1);
      var aa = [];
      var aaa = [];

      if(mode == "unsur"){
        //=== cari dari kamus
        fetchDictionaryDesc(a[0])
          .then(response => {
            response.data.map((e)=>{


              let hsl2 =  _.filter(this.state.featureType, function(obj) {
                return _.includes(obj.definition.toLowerCase(), e.wordTarget.toLowerCase());
              });

              let hsl3 =  _.filter(this.state.featureType, function(obj) {
                return _.includes(obj.typeName.toLowerCase(), e.wordTarget.toLowerCase());
              });

              let hsl4 =  _.filter(this.state.featureType, function(obj) {
                return _.includes(obj.code, e.wordTarget.toLowerCase());
              });

              let hslx = hsl2.concat(hsl3);
              let hslxx = hslx.concat(hsl4);
              hslxx = _.sortBy(hslxx, 'typeName');
 
              this.setState({resultSearchDic:hslxx});

            })

          }).catch(error => {
            console.log(error);
          });

          // === cari langsung
          let hsl2 =  _.filter(this.state.featureType, function(obj) {
            return _.includes(obj.definition.toLowerCase(), a[0].toLowerCase());
          });

          let hsl3 =  _.filter(this.state.featureType, function(obj) {
            return _.includes(obj.typeName.toLowerCase(), a[0].toLowerCase());
          });

          let hsl4 =  _.filter(this.state.featureType, function(obj) {
            return _.includes(obj.code, a[0].toLowerCase());
          });

          let hslx = hsl2.concat(hsl3);
          let hslxx = hslx.concat(hsl4);
          hslxx = _.sortBy(hslxx, 'typeName');

          this.setState({ loading: false, resultSearchAtribut:[], resultSearchAll:hslxx ,resultSearchDic:[], resultSearchDomain:[]});

      }

      if(mode == "atribut" || mode == "domain"){

        if(this.state.search == ""){
          return false
        }
        this.setState({ loading: true });

        let atribut = [];
        fetchKategori()
          .then(response => {
            response.data.map((e)=>{
              let typemode = 0;
              if(mode == "atribut"){
                typemode = 0;
              }else{
                typemode = 1;
              }
              this.setState({ loading: true });
              fetchSearchUnsur(e.featureCatalogId.replace("@en", ""), typemode,a[0])
                .then(response2 => {

                    response2.data.map((ee)=>{

                      //cek unsur fcName
                      let hslcekunsur =  _.filter(this.state.featureType, function(obj) {
                        return _.includes(obj.code, ee.code);
                      });

                      atribut.push({
                        typeName: hslcekunsur[0].typeName,
                        definition: hslcekunsur[0].definition,
                        featureCatalogueId: hslcekunsur[0].featureCatalogueId,
                        featureTypeID: hslcekunsur[0].featureTypeID,
                        typeName: hslcekunsur[0].typeName,
                        lvCode: ee.lvCode,
                        bfAtribute: ee.bfAtribute,
                        cardinality: ee.cardinality,
                        kode: ee.kode,
                        code: ee.code,
                        ptDefinition: ee.ptDefinition,
                        faValueMeasurementUnit: ee.faValueMeasurementUnit,
                        lvLabel: ee.lvLabel,
                        fcProducer1: ee.fcProducer1,
                        fcDefinitionReference1: ee.fcDefinitionReference1,
                        lvCodeDetail: ee.lvCodeDetail,
                        memberName: ee.memberName,
                        fcConstraint: ee.fcConstraint,
                        faValueType: ee.faValueType,
                        faCode: ee.faCode
                      });
                    })

                    console.log(atribut);

                    if(mode == "atribut"){
                      this.setState({ loading: false, resultSearchAtribut:atribut, resultSearchDic:[], resultSearchAll:[] ,resultSearchDic:[], resultSearchDomain:[]});
                    }else{
                      this.setState({ loading: false, resultSearchAtribut:[], resultSearchDic:[], resultSearchAll:[] ,resultSearchDic:[], resultSearchDomain:atribut});
                    }

                }).catch(error => {
                  console.log(error);
                });

            })
          }).catch(error => {
            console.log(error);
          });

      }



      }

     renderResultDic = (e)=>{
       return (
         <div className="container" style={{paddingTop:0}}>
           <h6>
             <a
             style= {{cursor:'pointer', color:'blue'}}
             onClick = {()=>{
               this.props.history.push(`/searchresult?fcid=${e.featureCatalogueId.replace("@en", "")}&code=${e.code.replace("@en", "")}`);
               this.props.pushSearchText(this.state.search);
              }
             }>
               {e.typeName.replace("@en", "") + " (" +getSkala(e.code)+")"}
             </a>
           </h6>
            <b>{e.aliases.replace("@en", "")}</b><br/>
            {e.definition.replace("@en", "")}
           <br/>
           <small>{e.code.replace("@en", "")}</small>
           <hr/>
         </div>
       )
     }

     renderResultAtribut = (e)=>{
       return (
         <div className="container" style={{paddingTop:0}}>
           <h6>
             <a
             style= {{cursor:'pointer', color:'blue'}}
             onClick = {()=>{
               this.props.history.push(`/searchresult?fcid=${e.featureCatalogueId.replace("@en", "")}&code=${e.code.replace("@en", "")}`);
               this.props.pushSearchText(this.state.search);
               }
             }>
               {e.typeName.replace("@en", "") + " (" +getSkala(e.code)+")"}
             </a>
           </h6>
            <b>{e.memberName.replace("@en", "")}</b><br/>
            {e.ptDefinition.replace("@en", "")}
           <br/>
           <small>{e.faValueType.replace("@en", "")}</small>
           <hr/>
         </div>
       )
     }

     renderResultDomain = (e)=>{
       return (
         <div className="container" style={{paddingTop:0}}>
           <h6>
             <a
             style= {{cursor:'pointer', color:'blue'}}
             onClick = {()=>{
               this.props.history.push(`/searchresult?fcid=${e.featureCatalogueId.replace("@en", "")}&code=${e.code.replace("@en", "")}`);
               this.props.pushSearchText(this.state.search);
               }
             }>
               {e.typeName.replace("@en", "") + " (" +getSkala(e.code)+")"}
             </a>
           </h6>
            <b>{e.memberName.replace("@en", "")}</b><br/>
            {e.lvCode.replace("@en", "")}
           <br/>
           <small>level code detail {e.lvCodeDetail.replace("@en", "")}</small>
           <hr/>
         </div>
       )
     }



    render(){
      const { classes } = this.props;

        return(

          <AUX>
            <div className="sweet-loading">
              <BarLoader
                css={override}
                height={4}
                width={300}
                color={"#E8EAF6"}
                loading={this.state.loading}
              />
            </div>
            <section className="sections" style = {{paddingTop:"5%"}}>
              <div className="container">
                <Grid item xs={12} style = {{paddingLeft:"10px"}}>


                    <Grid item xs={12} style = {{paddingRight:"100px"}}>

                      <Autocomplete
                        id="free-solo-demo"
                        freeSolo
                        options={this.state.optFeatureType.map((option) => option.typeName.replace("@en", ""))}
                        defaultValue = {this.state.search}
                        onChange={(event, value) => {this.setState({search: value})}}
                        renderInput={(params) => (
                          <form onSubmit={this.handleSubmit}>
                            <TextField
                              id="cari"
                              label="Pencarian..."
                              variant="outlined"
                              fullWidth
                              {...params}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment>
                                    <IconButton>
                                      <SearchIcon />
                                    </IconButton>
                                  </InputAdornment>
                                )
                              }}
                            />
                          </form>
                          )}
                      />
                    </Grid>
                  <FormControl component="fieldset">
                    <RadioGroup row aria-label="position" name="position" defaultValue="unsur">
                      <FormControlLabel
                        value="unsur"
                        control={<Radio color="primary" />}
                        label="unsur"
                        onClick={this.handleMode}
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="atribut"
                        control={<Radio color="primary" />}
                        label="atribut"
                        onClick={this.handleMode}
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="domain"
                        control={<Radio color="primary" />}
                        label="domain"
                        onClick={this.handleMode}
                        labelPlacement="start"
                      />
                    </RadioGroup>
                  </FormControl>

                  <br/>
                  <Paper elevation={0} style={{paddingTop:10}} >
                    {this.state.resultSearchDic.map(this.renderResultDic)}
                    {this.state.resultSearchAll.map(this.renderResultDic)}
                    {this.state.resultSearchAtribut.map(this.renderResultAtribut)}
                    {this.state.resultSearchDomain.map(this.renderResultDomain)}
                  </Paper>
                </Grid>
                <div className="container">
                    <div className="row justify-content-center" id="counter"/>
                </div>
              </div>
            </section>
          </AUX>
        )
      }

}

const mapStatetoProps = state => {

    return {
        islight: state.ui_red.islight,
        searchText: state.searchText
    };
}


export default withRouter(
  connect(
    mapStatetoProps, {pushCategory, pushUnsurAll, pushUnsurResultDic, pushUnsurResultAll, pushSearchText}
  )
  (PencarianKugi)
);
